// @ts-nocheck
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SideMenuComponent from "@store/Library/Components/Toolkit/SideMenu";
import React, { FC } from "react";

const enum fields {
    page = "page",
    showRootPage = "showRootPage",
    showSignOut = "showSignOut",
}

interface Props extends WidgetProps {
    fields: {
        [fields.page]: LinkFieldValue;
        [fields.showRootPage]: boolean;
        [fields.showSignOut]: boolean;
    };
}

const SideMenu: FC<Props> = ({ fields: { page, showRootPage, showSignOut } }) => {
    return <SideMenuComponent nodeId={page?.value} showRootPage={showRootPage} showSignOut={showSignOut} />;
};

const widgetModule: WidgetModule = {
    component: SideMenu,
    definition: {
        group: "Basic",
        icon: "bars",
        fieldDefinitions: [
            {
                name: fields.page,
                displayName: "Page",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
                allowUrls: x => false,
                allowCategories: x => false,
            },
            {
                name: fields.showRootPage,
                displayName: "Show selected page in menu",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.showSignOut,
                displayName: 'Show "Sign Out" button',
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
